import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useCompanyChatSessions = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();

    const [chatSessions, setChatSessions] = useState([]);
    const [totalChatSessions, setTotalChatSessions] = useState(0);

    useEffect(() => {
        const fetchChatSessions = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });

            try {
                const response = await getData(`${baseUrl.chatSessionsCount}?${query}`);
                if (response?.success) {
                    setChatSessions(response?.data?.items || []);
                    setTotalChatSessions(response?.data?.allCompaniesTotalChatSessions || 0);
                }
            } catch (err) {
                console.error("Failed to fetch chat sessions", err);
                setChatSessions([]);
                setTotalChatSessions(0);
            }
        };

        fetchChatSessions();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        isChatSessionsLoading: isLoading,
        totalChatSessions,
        companyChatSessions: chatSessions
    };
};
